export const STENCIL_ROUTE_TRANSITION_TIMEOUT_MS = 15000;

// Pointer and keyboard events only. Focus and input events are excluded on purpose: ODSU fires
// them while hydrating a route, and treating those as user interaction would push route renders
// out of the atomic drain and let the browser paint a half-hydrated screen.
export const STENCIL_INTERACTION_EVENTS = [
    'pointerdown',
    'pointerup',
    'mousedown',
    'mouseup',
    'click',
    'dblclick',
    'keydown',
    'keyup',
] as const;

// ODSU's select waits until the next frame before deciding whether an option interaction should
// close it. Only interactions originating in that widget need to cross a task boundary; applying
// the exception globally lets the browser paint newly mounted modals before Stencil renders them.
export const STENCIL_DEFERRED_INTERACTION_COMPONENTS: readonly string[] = ['owc-select-dropdown'];

// Upper bound for the deferred drain loop, so a component that re-renders itself forever cannot
// lock the task.
export const STENCIL_MAX_DRAIN_PASSES = 300;

// Consecutive empty microtask passes before the drain considers the cascade finished. Stencil
// chains renders through promise continuations, so an empty queue does not mean "no more work".
export const STENCIL_DRAIN_SETTLE_PASSES = 2;
